<template>
  <div class="container mt-4">
    <b-row>
      <b-col cols="12">
        <b-card no-body>
          <b-card-body>

              <b-form v-on:submit.prevent="search">

                <b-form-group>
                  <b-form-radio-group
                    buttons
                    name="lang"
                    :options="langs"
                    value-field="id"
                    text-field="title"
                    v-model="searchFilter.langid"
                    button-variant="outline-primary">
                  </b-form-radio-group>
                </b-form-group>

                <b-form-group label-for="text">
                    <b-input-group>
                      <vue-simple-suggest
                        id="text"
                        ref="wordInput"
                        :min-length="2"
                        style="font-size:24px"
                        class="f-control"
                        placeholder="Введите слово..."
                        display-attribute="srcWord"
                        value-attribute="srcWord"
                        v-model="searchFilter.word"
                        :list="getSuggestionList"
                        @select="selectWord"
                        autocomplete='off'>
                        <input v-model="searchFilter.word" v-on:keyup.enter="selectWord">
                      </vue-simple-suggest>
                      <b-input-group-append>
                        <b-button v-if="searchFilter.word!=''" type="button" variant="light" @click.prevent="clear"><i class="fa fa-remove fa-lg"></i></b-button>
                        <b-button type="submit" variant="primary"><i class="px-2 fa fa-search fa-lg"></i></b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>

                <b-row v-if="searchFilter.langid==1" class="mb-4">
                    <b-col>
                        <b-button @click.prevent="letter" class="mr-2" variant="outline-dark">ӝ</b-button>
                        <b-button @click.prevent="letter" class="mr-2" variant="outline-dark">ӟ</b-button>
                        <b-button @click.prevent="letter" class="mr-2" variant="outline-dark">ӥ</b-button>
                        <b-button @click.prevent="letter" class="mr-2" variant="outline-dark">ӧ</b-button>
                        <b-button @click.prevent="letter" class="mr-2" variant="outline-dark">ӵ</b-button>
                    </b-col>
                </b-row>

                <b-row v-if="words.length>0" class="mb-4">
                    <b-col>
                       <span class="font-weight-bold" v-for="(word, index) in words" :key="index">
                           <span class="link" @click="repeat(word)">{{ word.name }}</span><span class="pl_2" v-if="index < words.length - 1">, </span>
                       </span>
                    </b-col>
                </b-row>

              </b-form>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>

    <transition name="slide-fade">
    <b-row v-if="show">
      <b-col cols="12">
        <div v-if="loadedState == 1" class="loadingChartData">
            <LoadingSpinner/>
        </div>

        <div v-else-if="loadedState == 2">
          <b-card no-body v-if="terms.length == 0">
            <b-card-body>
              Ничего не найдено
            </b-card-body>
          </b-card>
          
          <b-card no-body v-else v-for="t in terms" :key="t.id">
            <b-card-body>
              <div class="dictText" v-html="t.body"/>
              <audio class="mt-2 minplayer" v-if="t.haveSound" :src="'/res/mp3/0_term_'+t.id+'_1.mp3'" controls></audio>
            </b-card-body>
          </b-card>
        </div>

      </b-col>
    </b-row>
    </transition>

  </div>
</template>

<script>
  import LoadingSpinner from '@/components/utils/LoadingSpinner'

  import VueSimpleSuggest from 'vue-simple-suggest'
  import 'vue-simple-suggest/dist/styles.css'

  import { langService } from '@/_services'

  import { validationMixin } from "vuelidate"
  import { required, minLength, email, sameAs, helpers } from "vuelidate/lib/validators"

  import { mapMutations, mapState } from 'vuex';

  export default {
    name: 'dictionary',
    components:{
      LoadingSpinner,
      VueSimpleSuggest
    },
    mixins: [validationMixin],
    validations: {
      searchFilter: {
        word: {
          required,
          minLength: minLength(2)
        }
      }
    },
    mounted() {
      this.$v.$touch();
      this.loadLang();
    },
    computed: {
      ...mapState('word', ['words']),
      isValid() { return !this.$v.searchFilter.$anyError },
    },
    methods: {
      ...mapMutations('word', [ 'addWord']),
      clear(){
        this.searchFilter.word=""
        this.$refs.wordInput.input.focus()
      },
      letter(e){
        this.searchFilter.word+=e.target.innerText
        this.$refs.wordInput.input.focus()
      },
      repeat(word){
        this.searchFilter.word=word.name
        this.searchFilter.langid=word.lang.id
        this.search()
      },
      loadLang() {
        langService.list().then(
         data => {
            this.langs = data;
            this.searchFilter.langid = this.langs[0].id;
          }
        )
      },
      getSuggestionList() {
        this.searchFilter.lang=this.langs.filter(c => c.id == this.searchFilter.langid)[0];
        return langService.suggestion(this.searchFilter)
        .then(data => data)
      },
      selectWord(){
        this.search()
      },
      chkState(val) {
        const field = this.$v.searchFilter[val]
        return !field.$dirty || !field.$invalid
      },
      validate() {
        this.$v.$touch()
        return this.isValid
      },
      search(){
        this.show=false;
        this.loadedState = 0;
        this.searchFilter.lang=this.langs.filter(c => c.id == this.searchFilter.langid)[0];
        this.loadedState = 1;
        this.searchFilter.word = this.searchFilter.word.toLowerCase().trim()
        langService.search(this.searchFilter)
        .then(data => {
          this.show=true;
          this.terms = data;
          this.loadedState = 2;
          if(data.length>0) this.addWord({"name":this.searchFilter.word, "lang":this.searchFilter.lang});
        })
      }
    },
    data(){
      return {
        show:false,
        langs:[],
        terms:[],
        searchFilter:{
          langid:0,
          lang:null,
          word:""
        },
        loadedState:0
      }
    }
  }
</script>

<style>
  .dictText .b {font-weight: bold;}
  .dictText .i {font-style: italic;}
  .dictText .apos {position: relative;}
  .dictText .apos:after {content: '\301';position: absolute;top: -2px;left: 4px;}
  .dictText .m1 {display:block;margin: 5px 0 0 20px;}
  .dictText .m2 {display:block;margin: 5px 0 0 40px;}
  .dictText .m3 {display:block;margin: 5px 0 0 60px;}
  .dictText .m4 {display:block;margin: 5px 0 0 80px;}
  .dictText .m5 {display:block;margin: 5px 0 0 100px;}
</style>

<style lang="scss" scoped>
@import '../assets/scss/style';
  .link {cursor: pointer;}

@include media-breakpoint-down($breakpoint-mobile-down) {
    .container {padding:0px;}
    .minplayer {width:150px;}
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 1s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}

.slide-fade-enter-active {
  transition: all 0.5s ease;
}
.slide-fade-leave-active {
  transition: all 0.5s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter, .slide-fade-leave-to {
  transform: translateY(-20px);
  opacity: 0.5;
}
.slide-fade-leave {
  transform: translateY(20px);
  opacity: 1;
}
.f-control {flex: 1 1 auto;}
</style>